<template>
  <div class="card is-smallshadow">
    <div class="card-body py-3">
      <h2 class="heading-small text-grey mb-2">
        {{ $t('UserSettingsPasswordChange.passwordChange') }}
      </h2>

      <div class="width-narrow">
        <validation-observer
          ref="user-settings-passowrd-form"
          tag="form">
          <div class="form-group">
              <label for="password">
                {{ $t('UserSettingsPasswordChange.newPassword') }}
              </label>

              <validation-provider
                rules="required|min:8"
                name="password"
                v-slot="{ errors }">
                <f-input
                  type="password"
                  :state="errors.length ? 'invalid' : null"
                  v-model="password" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="password-confirmation">
                {{ $t('user.repeatPassword') }}
              </label>

              <validation-provider
                :rules="'required|min:8|password:password'"
                name="password-confirmation"
                v-slot="{ errors }">
                <f-input
                  type="password"
                  :state="errors.length ? 'invalid' : null"
                  v-model="password_confirmation" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
        </validation-observer>
      </div>
    </div>
    <div class="card-footer pt-3 pb-4 text-right">
      <f-button
        theme="primary"
        big
        :disabled="submitting"
        @click.prevent="validateForm">
        {{ $t('ui.save') }}
      </f-button>
    </div>
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'user-settings-passowrd-change',
  data() {
    return {
      password: null,
      password_confirmation: null,
      submitting: false
    }
  },
  methods: {
    submitForm () {
      this.submitting = true;

      let formDataToSend = {
        password: this.password,
        password_confirmation: this.password_confirmation,
      }

      FormUtils.submitWithConfirm(this, {
        endpoint: '/api/auth/change-password',
        formData: formDataToSend,
        successTitle: this.$t('UserSettingsPasswordChange.passwordSave'),
        successText: this.$t('UserSettingsPasswordChange.passwordHasBeenChange'),
        confirmTitle: this.$t('UserSettingsPasswordChange.areYouSureToChangePassword'),
        confirmText: this.$t('ui.thisOperationCannotUndone'),
        confirmButtonText: this.$t('ui.yesChange'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('UserSettingsPasswordChange.passwordChangeError'),
        successAction: () => {
          this.submitting = false;
          this.password = null;
          this.password_confirmation = null;

          if (this.$refs['user-settings-passowrd-form']) {
            this.$refs['user-settings-passowrd-form'].reset();
          }
        },
        cancelAction: () => {}
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['user-settings-passowrd-form'], this.submitForm);
    },
  }
}
</script>
